
<component
  :is="as"
  class="add-link"
  v-bind="$attrs"
  v-on="$listeners"
>
  <icon class="icon" name="add" />

  <span>
    <slot />
  </span>
</component>
